import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";

const Toast = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const HeaderText = styled.div`
  color: ${styleTokens.Surface.Text.main};
  font-family: ${styleTokens.fontFamily.Inter};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.14px;
`;

const SubText = styled.div`
  color: ${styleTokens.Surface.Text.main};
  font-family: ${styleTokens.fontFamily.Inter};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.14px;
`;

export const BaseToastStyle = {
  Toast,
  Header,
  HeaderText,
  SubText,
};
